/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/**
 * Each section has a summary card.
 * This enumeration contains all the summary sections that need custom code handling.
 *   *other sections might exist in the submission form that are not declared here
 *    because they do not require custom code
 */
export const SubmissionSectionType = Object.freeze({
  BASIC_FILING: 'basicFilingInfo',
  REQUEST_INFO: 'requestInformation',
  PARTIES: 'parties',
  ATTACHMENTS: 'attachments',
  SEQLBIO: 'seqlBio',
  FEES: 'fees',
  DECLARATIONS: 'declaration',
  ADDITIONAL_NOTES: 'additionalNotes',
  SIGNATURES: 'signatures',
  RECEIPT: 'receipt',
  ATTACHMENTS_PREVIEW: 'attachmentsPreview',
});
